<div class="dashboard-messages or-mx-16-px" [class.or-mt-16-px]="!!messages()?.length">
  @for (msg of messages(); track msg.id) {
    <div class="dm-card dm-card--{{ msg.id }}" [class.dm-card--clickable]="msg.clickable" (click)="onClick(msg)">
      @if (msg.hasIcon) {
        <span class="dm-card__icon"></span>
      }

      <div class="dm-card__body">
        <div class="or-head-sm">{{ msg.title }}</div>
        <div class="or-text-sm or-color-secondary-2 or-mt-4-px">{{ msg.subtitle }}</div>
      </div>

      @if (msg.action === 'close') {
        <button
          class="dm-card__action dm-card__action--close"
          type="button"
          aria-label="Zamknij"
          (click)="onDismiss(msg, $event)"></button>
      } @else if (msg.action === 'chevron') {
        <span class="dm-card__action dm-card__action--chevron"></span>
      }
    </div>
  }
</div>
